import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getLabs(fetch: Fetch, bucketId: number) {
  return fetch(
    `/labs?bucketId=${bucketId}`,
    { method: 'get' },
    schemas.LabsResponse
  );
}

export const useLabsByBucketIdQuery = (bucketId: number) => {
  return useQuery({
    queryKey: ['labByBucketId', bucketId],
    retry: false,
    queryFn: async () => {
      const labs = await getLabs(fetch, bucketId);
      if (!labs || labs.labs.length === 0) {
        throw new Error('No labs found with bucketId ' + bucketId);
      }
      return labs.labs[0];
    }
  });
};
